module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nrUBhr/tc-custom/9781504060677.jpg?1702610651599",
      "alt": "This image is the cover for the book Killings"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Killings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Two LAPD detectives are at odds over a horrifying case in this “taut shocker” of a novel by an Edgar Award–winning author ("), _c('i', [_vm._v("The Boston Globe")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A pair of twins have been brutally murdered, and Los Angeles detectives George Cascade and Ed Fenner find themselves working a case with puzzling sexual overtones. When a young, intellectually disabled African American becomes the object of suspicion, tensions flare between the two officers—and it will push them to the edge before the truth can be sorted out."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “The kind of book you read at the point of a switchblade—seemingly faster than you can turn the pages.” —"), _c('i', [_vm._v("Kirkus Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clark Howard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Clark Howard (1932-2016) Born in Ripley, Tennessee, Howard was one of the most honored mystery writers in America and was a longtime favorite of readers of Ellery Queen Mystery Magazine, Alfred Hitchcock Mystery Magazine, and numerous other publications. A professional writer for over 40 years, he wrote sixteen novels, six books of non-fiction, and published two collections of short stories, in addition to more than 200 uncollected short stories. Howard was honored with the Edgar Allan Poe award for best short story of 1981 from the Mystery Writers of America. In 2009, Howard won the Edward D. Hoch Memorial Golden Derringer Award for Lifetime Achievement from the Short Fiction Mystery Society.​  ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0